export const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const timezones = [
    {label: 'Pacific', value: 'America/Los_Angeles'},
    {label: 'Mountain', value: 'America/Denver'},
    {label: 'Central', value: 'America/Chicago'},
    {label: 'Eastern', value: 'America/New_York'},
];
export function defaultTimeValue() {
    return {start: '9:00 AM', end: '5:00 PM', tz: 'America/Los_Angeles', days: [1, 2, 3, 4, 5]};
}
export function readConditionValue(value, fallback) {
    try {const parsed = JSON.parse(value); return parsed && typeof parsed === 'object' ? parsed : fallback;} catch (error) {return fallback;}
}
export function defaultDateValue() {
    return {dates: [], recurring: false};
}
export function calendarDateKey(date, recurring = false) {
    const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return recurring ? monthDay : `${String(date.getFullYear()).padStart(4, '0')}-${monthDay}`;
}
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function formatConditionDate(value, recurring = false) {
    const [year, month, day] = (recurring ? `2000-${value}` : value).split('-').map(Number);
    const label = `${months[month - 1]} ${day}`;
    return recurring ? label : `${weekdays[new Date(year, month - 1, day).getDay()]}, ${label}, ${year}`;
}
export function conditionOperatorsFor(slug, operators = []) {
    const allowed = slug === 'time' ? ['within', 'not_within'] : slug === 'date' ? ['on', 'not_on'] : ['=', 'in', '!in'];
    return operators.filter(operator => allowed.includes(operator.message_automation_condition_operator_slug));
}
export function conditionTitle(condition, definitions) {
    const type = definitions.conditionTypes?.find(item => String(item.message_automation_condition_type_id) === String(condition.message_automation_condition_type_id));
    const operator = definitions.conditionOperators?.find(item => String(item.message_automation_condition_operator_id) === String(condition.message_automation_condition_operator_id));
    if (type?.message_automation_condition_type_slug === 'date') {
        const value = readConditionValue(condition.message_automation_condition_value, defaultDateValue());
        return `Date ${operator?.message_automation_condition_operator_slug === 'not_on' ? 'is not' : 'is'} ${(value.dates || []).map(day => formatConditionDate(day, value.recurring)).join(', ')}${value.recurring ? ' (every year)' : ''}`;
    }
    if (type?.message_automation_condition_type_slug === 'time') {
        const value = readConditionValue(condition.message_automation_condition_value, defaultTimeValue());
        const days = value.days.length === 7 ? 'every day' : value.days.map(day => weekdays[day]).join(', ');
        const timezone = timezones.find(zone => zone.value === value.tz)?.label || value.tz;
        return `Time of Day ${operator?.message_automation_condition_operator_slug === 'not_within' ? 'not within' : 'within'} ${value.start}–${value.end} (${timezone}), ${value.activeDaysOnly ? 'active on ' : ''}${days}`;
    }
    return `${type?.message_automation_condition_type_title || 'Unknown Field'} ${operator?.message_automation_condition_operator_title || 'Unknown Operator'} "${condition.message_automation_condition_value || ''}"`;
}
